function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.4668,18.0019 L0.5328,18.0019 C0.2388,18.0019 -0.0002,17.7629 -0.0002,17.4689 L-0.0002,16.5349 C-0.0002,16.2409 0.2388,16.0019 0.5328,16.0019 L14.4668,16.0019 C14.7608,16.0019 14.9998,16.2409 14.9998,16.5349 L14.9998,17.4689 C14.9998,17.7629 14.7608,18.0019 14.4668,18.0019 Z M13.7236,4.0849 C13.5286,4.2699 13.2216,4.2679 13.0296,4.0789 L10.7936,1.8909 C10.5856,1.6889 10.5946,1.3529 10.8106,1.1599 L11.8026,0.2779 C12.2346,-0.1071 12.8916,-0.0901 13.3036,0.3159 L14.6836,1.6729 C15.1116,2.0929 15.1046,2.7749 14.6696,3.1869 L13.7236,4.0849 Z M9.9395,2.56 L12.2215,4.794 C12.4245,4.992 12.4215,5.319 12.2155,5.514 L3.5795,13.703 C3.3765,13.895 3.1085,14.002 2.8295,14.002 L0.5005,14.002 C0.2235,14.002 0.0005,13.778 0.0005,13.502 L0.0005,11.283 C0.0005,10.982 0.1305,10.694 0.3605,10.492 L9.2565,2.545 C9.4525,2.37 9.7515,2.376 9.9395,2.56 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-3 -2 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/edit.811cae08.svg";
export { SvgComponent as ReactComponent };